// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__142v0","file":"styles_file__D2knb"};